import React from 'react'
import { Dialog, makeStyles } from '@material-ui/core'
import GlueScroll from '../glueos-components/glue-scroll'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import GlueButton from '../glueos-components/glue-button'

const useStyles = makeStyles(theme => ({
  root: {
    width: '1152px',
    height: '976px',
    overflow: 'hidden',
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing('m'),
    paddingBottom: theme.spacing('xl')
  },

  topBar: {
    height: '64px',
    display: 'grid',
    gridTemplateColumns: '1fr 3fr 1fr'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  closeButton: {
    display: 'flex',
    justifyContent: 'end'
  },

  scrollContent: {
    width: '960px',
    marginRight: '40px',
    marginLeft: 'auto'
  }
}), { name: 'MuiGluePolicyDialog' })

const PolicyDialog = (props) => {
  const classes = useStyles()

  return (
    <Dialog
      open={!!props.open}
      maxWidth={false}
    >
      <div className={classes.root}>
        <div className={classes.topBar}>
          <div />
          <div className={classes.title}>
            <h1>{props.title}</h1>
          </div>
          <div className={classes.closeButton}>
            <GlueButton variant='icon' color='stealth' onPointerDown={props.onCloseDialog}><CloseOutlinedIcon /></GlueButton>
          </div>
        </div>
        <GlueScroll>
          <div className={classes.scrollContent}>
            {props.children}
          </div>
        </GlueScroll>
      </div>
    </Dialog>
  )
}

export default PolicyDialog
